import { Link } from "gatsby";
import React, { useState, ChangeEvent } from "react";
import styled from "styled-components";
import SongListTile from "./SongListTile";
// import SongListTile from "./SongListTileWithAmazonLink";
import { FaSearch } from "react-icons/fa"; // Import the search icon

const AutocompleteContainer = styled.div`
  position: relative;
  width: 100%;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const InputIcon = styled(FaSearch)`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #aaa;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 10px 10px 30px; // Adjust padding to make space for the icon
  border: 1px solid #aaa;
  border-radius: 4px;
`;

const Ul = styled.ul`
  padding-left: 0;
  list-style: none;
`;
const Li = styled.li`
  margin: 8px 0;
`;

interface Props {
  songs: { node: Queries.ChordsJson }[];
}

const Autocomplete: React.FC<Props> = ({ songs }) => {
  const [query, setQuery] = useState<string>("");
  const [filteredSongs, setFilteredSongs] = useState<Queries.ChordsJson[]>(
    songs.map(({ node }) => node)
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const userInput = e.target.value;
    setQuery(userInput);

    const filtered = userInput
      ? songs.filter(
          ({ node: { title, artists } }) =>
            title
              ?.toLocaleLowerCase()
              .includes(userInput.toLocaleLowerCase()) ||
            artists
              ?.join(",")
              .toLocaleLowerCase()
              .includes(userInput.toLocaleLowerCase())
        )
      : songs;
    setFilteredSongs(filtered.map(({ node }) => node));
  };

  return (
    <AutocompleteContainer>
      <InputContainer>
        <InputIcon />
        <Input
          type="text"
          onChange={handleChange}
          value={query}
          placeholder="曲名・アーティスト名で検索"
        />
      </InputContainer>
      <Ul>
        {0 < filteredSongs.length ? (
          filteredSongs.map((song) => (
            <Li key={song.slug}>
              <SongListTile
                title={song.title}
                subtitle={song.subtitle}
                artists={song.artists}
                slug={song.slug}
                youtubeVideoId={song.youtubeVideoId}
                // asin={song.asin}
              />
            </Li>
          ))
        ) : (
          <div>
            <p>申し訳ございません。見つかりませんでした🙇</p>
            <Link to={`/request?q=${query}`}>{query} をリクエストする</Link>
          </div>
        )}
      </Ul>
    </AutocompleteContainer>
  );
};

export default Autocomplete;
